/**
 * Autohero Trustpilot Configuration
 * Locale-specific Trustpilot business unit IDs and settings for Autohero cross-promo banner
 */

// Autohero Trustpilot business unit IDs per locale
export const TRUSTPILOT_AUTOHERO_BUSINESS_UNITS = {
  'de-DE': '55095b7c0000ff00057e21a1',
  'es-ES': '60415a650e27ef00017f358a',
  'fr-FR': '60415a753730b80001c85fdc',
  'it-IT': '60415a6b4919ec0001a758bd',
  'nl-NL': '60415a6f0d40af00014f4e79',
  'nl-BE': '60415a6182d4930001d274cd',
  'fr-BE': '60415a6182d4930001d274cd',
  'de-AT': '60415a680d40af00014f4e77',
  'sv-SE': '60415a650e27ef00017f358a'
};

// Trustpilot template ID for micro-star widget (desktop)
export const TRUSTPILOT_TEMPLATE_ID = '5419b6ffb0d04a076446a9af';

// Widget styling configuration
export const TRUSTPILOT_WIDGET_CONFIG = {
  theme: 'dark',
  height: '42px',
  width: '320px',
  fontFamily: 'Open Sans'
};

// Autohero Trustpilot profile URLs per locale
// Pattern: https://{language}.trustpilot.com/review/autohero.com/{language}
export const TRUSTPILOT_AUTOHERO_URLS = {
  'de-DE': 'https://de.trustpilot.com/review/autohero.com/de',
  'es-ES': 'https://es.trustpilot.com/review/autohero.com/es',
  'fr-FR': 'https://fr.trustpilot.com/review/autohero.com/fr',
  'it-IT': 'https://it.trustpilot.com/review/autohero.com/it',
  'nl-NL': 'https://nl.trustpilot.com/review/autohero.com/nl',
  'nl-BE': 'https://nl-be.trustpilot.com/review/autohero.com/nl-be',
  'fr-BE': 'https://fr-be.trustpilot.com/review/autohero.com/nl-be',
  'de-AT': 'https://at.trustpilot.com/review/autohero.com/at',
  'sv-SE': 'https://se.trustpilot.com/review/autohero.com/se'
};

/**
 * Get complete Trustpilot configuration for a given locale
 * @param {string} fullLocale - Full locale string (e.g., 'es-ES', 'fr-FR', 'it-IT')
 * @returns {object} Trustpilot configuration object
 */
export const getTrustpilotAutoheroConfig = fullLocale => {
  const businessUnitId = TRUSTPILOT_AUTOHERO_BUSINESS_UNITS[fullLocale] || TRUSTPILOT_AUTOHERO_BUSINESS_UNITS['de-DE'];

  // Extract short locale for review languages (e.g., 'es' from 'es-ES')
  const reviewLanguage = fullLocale ? fullLocale.split('-')[0] : 'de';

  // Get Trustpilot profile URL
  const href = TRUSTPILOT_AUTOHERO_URLS[fullLocale] || TRUSTPILOT_AUTOHERO_URLS['de-DE'];
  return {
    businessUnitId,
    templateId: TRUSTPILOT_TEMPLATE_ID,
    locale: fullLocale || 'de-DE',
    reviewLanguages: reviewLanguage,
    href,
    ...TRUSTPILOT_WIDGET_CONFIG
  };
};